"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeAggregate = exports.encodeAggregate = void 0;
var encoder_1 = require("./encoder");
Object.defineProperty(exports, "encodeAggregate", { enumerable: true, get: function () { return encoder_1.encodeAggregate; } });
var decoder_1 = require("./decoder");
Object.defineProperty(exports, "decodeAggregate", { enumerable: true, get: function () { return decoder_1.decodeAggregate; } });
//# sourceMappingURL=index.js.map